import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import ApplicationErrorBoundary from "@/components/app/ApplicationErrorBoundary";
import { configureErrorTracking } from "@/lib/errorTracking";

configureErrorTracking();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ApplicationErrorBoundary><App /></ApplicationErrorBoundary>
    </QueryClientProvider>
  </React.StrictMode>,
);
